import PersonIcon from "@mui/icons-material/Person";
import { Box, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getNearByChefs } from "../firebase/user";
import User from "../interfaces/User";
import { RootState } from "../redux/store";
import ChefProfileCard from "./browse/ChefProfileCard";
import NoDataUI from "./NoDataUI";

const NearbyChefs = () => {
  const userAddress = useSelector(
    (state: RootState) => state.user.user.address
  );
  const [chefsData, setChefsData] = useState<User[]>([]);

  async function fetchNearByChefs() {
    if (userAddress) {
      const nearByChefs: User[] = await getNearByChefs(
        userAddress.lat,
        userAddress.lng
      );
      nearByChefs && setChefsData(nearByChefs);
    }
  }

  useEffect(() => {
    fetchNearByChefs();
  }, []);

  return (
    <Box>
      {chefsData.length > 0 ? (
        <Grid container spacing={3}>
          {chefsData.map((chef, index) => {
            return (
              <Grid key={index} item xs={12} md={6}>
                <ChefProfileCard chef={chef} />
              </Grid>
            );
          })}
        </Grid>
      ) : (
        <NoDataUI Icon={PersonIcon} displayMessage={"No chefs near you"} />
      )}
    </Box>
  );
};

export default NearbyChefs;
